import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import './Error.css';

// Lazy load components
const Layout = lazy(() => import('./Layout'));
const SocialMediaMarketing = lazy(() => import('./pages/social-media-marketing/page'));
const DigitalMarketing = lazy(() => import('./pages/digital-marketing-services/page'));
const WebDevelopment = lazy(() => import('./pages/web-development/page'));
const AppDevelopment = lazy(() => import('./pages/app-development/page'));
const PrivacyPolicy = lazy(() => import('./pages/privacy-policy/page'));
const TermsConditions = lazy(() => import('./pages/terms-conditions/page'));
const WindowScroll = lazy(() => import('./pages/window/WindowScroll'));
const HomePage = lazy(() => import('./components/Home/HomePage'));
const AboutUs = lazy(() => import('./pages/about-us/page'));
const Career = lazy(() => import('./pages/careers/page'));
const Contact = lazy(() => import('./pages/contact-us/page'));
const Error = lazy(() => import('./pages/error/Error'));
const PPC = lazy(() => import('./pages/ppc/page'));
const SEO = lazy(() => import('./pages/seo/page'));
const Blog = lazy(() => import('./pages/blog/page'));
const CustomIntegrationPage = lazy(() => import('./components/CustomIntegration/CustomIntegrationPage'));
const PerformanceOptimizationPage = lazy(() => import('./components/PerformanceOptimization/PerformanceOptimizationPage'));
const UiUxDesignPage = lazy(() => import('./components/UiUxDesign/UiUxDesignPage'));
const Ecommerce = lazy(() => import('./pages/Ecommerce/page'));
const SoftwareDevelopment = lazy(() => import('./pages/SoftwareDevelopment/page'));
const GameDevelopment = lazy(() => import('./pages/GameDevelopment/page'));
const ApiDevelopment = lazy(() => import('./pages/ApiDevelopment/page'));
const ModernAiChatbot = lazy(() => import('./pages/ModernAiChatbot'));
const AiSettingsPage = lazy(() => import('./pages/AiSettings/page'));
const ArtificialIntelligence = lazy(() => import('./pages/artificial-intelligence/page'));
const Blockchain = lazy(() => import('./pages/blockchain/page'));
const CyberSecurity = lazy(() => import('./pages/cyber-security/page'));
const Cloud = lazy(() => import('./pages/cloud/page'));
const DataAnalytics = lazy(() => import('./pages/data-analytics/page'));
const DataEngineering = lazy(() => import('./pages/data-engineering/page'));
const EmailMarketing = lazy(() => import('./pages/email-marketing/page'));
const ContentMarketing = lazy(() => import('./pages/content-marketing/page'));
const AffiliateMarketing = lazy(() => import('./pages/affiliate-marketing/page'));
const CreativeServices = lazy(() => import('./pages/creative-services/page'));
const AiMarketingServices = lazy(() => import('./pages/ai-marketing-services/page'));
const BrandingServices = lazy(() => import('./pages/branding-services/page'));
// our work
const Works = lazy(() => import('./pages/works/page'));
const WorkDetails = lazy(() => import('./pages/WorkDetails/page'));

// Industries
const IndBanking = lazy(() => import('./pages/industries/banking/page'));
const IndCapitalMarkets = lazy(() => import('./pages/industries/capital-markets/page'));
const IndConsumerGoods = lazy(() => import('./pages/industries/consumer-goods-and-distribution/page'));
const IndCommunicationMediaServices = lazy(() => import('./pages/industries/communication-media-and-services/page'));
const IndEducation = lazy(() => import('./pages/industries/education/page'));
const IndEnergyResourcesUtilities = lazy(() => import('./pages/industries/energy-resources-and-utilities/page'));
const IndGemsJewellery = lazy(() => import('./pages/industries/gems-and-jewellery/page'));
const IndHealthcare = lazy(() => import('./pages/industries/healthcare/page'));
const IndHighTech = lazy(() => import('./pages/industries/high-tech/page'));
const IndInformationTechnology = lazy(() => import('./pages/industries/information-technology/page'));
const IndInsurance = lazy(() => import('./pages/industries/insurance/page'));
const IndLifeSciences = lazy(() => import('./pages/industries/life-sciences/page'));
const IndManufacturing = lazy(() => import('./pages/industries/manufacturing/page'));
const IndPublicService = lazy(() => import('./pages/industries/public-service/page'));
const IndRetail = lazy(() => import('./pages/industries/retail/page'));
const IndRealEstate = lazy(() => import('./pages/industries/real-estate/page'));
const IndTravelLogistics = lazy(() => import('./pages/industries/travel-and-logistics/page'));
const TestComponent = lazy(() => import('./test'));
const ServiceSection = lazy(() => import('./components/ui/ServiceSection'));

// Loading component for Suspense fallback
// const LoadingFallback = () => (
//   <div className="min-h-screen flex items-center justify-center">
//     <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
//   </div>
// );


function App() {
  return (
    <ThemeProvider>
      {/* <HelmetProvider> */}
        <BrowserRouter>
          {/* <Suspense fallback={<LoadingFallback />}> */}
          <Suspense >
            {/* <WindowScroll /> */}
            <Routes>
            <Route element={<Layout />}>
            <Route path='/' element={<Suspense>
              <HomePage />
            </Suspense>} />
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/careers' element={<Career />} />
            <Route path='/contact-us' element={<Contact />} />
            <Route path='/social-media-marketing' element={<SocialMediaMarketing />} />
            <Route path='/digital-marketing-services' element={<DigitalMarketing />} />
            <Route path='/seo' element={<SEO />} />
            <Route path='/ppc' element={<PPC />} />
            <Route path='/ppc' element={<Blog />} />
            <Route path='/web-development' element={<WebDevelopment />} />
            <Route path='/app-development' element={<AppDevelopment />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/terms-conditions' element={<TermsConditions />} />
            <Route path='/ecommerce-development' element={<Ecommerce />} />
            <Route path='/software-development' element={<SoftwareDevelopment />} />
            <Route path='/game-development' element={<GameDevelopment />} />
            <Route path='/api-development' element={<ApiDevelopment />} />
            <Route path='/custom-integration' element={<CustomIntegrationPage />} />
            <Route path='/performance-optimization' element={<PerformanceOptimizationPage />} />
            <Route path='/ui-ux-design' element={<UiUxDesignPage />} />
            <Route path='/artificial-intelligence' element={<ArtificialIntelligence />} />
            <Route path='/blockchain' element={<Blockchain />} />
            <Route path='/cyber-security' element={<CyberSecurity />} />
            <Route path='/cloud' element={<Cloud />} />
            <Route path='/data-analytics' element={<DataAnalytics />} />
            <Route path='/data-engineering' element={<DataEngineering />} />
            <Route path='/email-marketing' element={<EmailMarketing />} />
            <Route path='/content-marketing' element={<ContentMarketing />} />
            <Route path='/affiliate-marketing' element={<AffiliateMarketing />} />
            <Route path='/creative-services' element={<CreativeServices />} />
            <Route path='/ai-marketing-services' element={<AiMarketingServices />} />
            <Route path='/branding-services' element={<BrandingServices />} />
           
            <Route path='/industries/banking' element={<IndBanking />} />
            <Route path='/industries/capital-markets' element={<IndCapitalMarkets />} />
            <Route path='/industries/consumer-goods-and-distribution' element={<IndConsumerGoods />} />
            <Route path='/industries/communication-media-and-services' element={<IndCommunicationMediaServices />} />
            <Route path='/industries/education' element={<IndEducation />} />
            <Route path='/industries/energy-resources-and-utilities' element={<IndEnergyResourcesUtilities />} />
            <Route path='/industries/gems-and-jewellery' element={<IndGemsJewellery />} />
            <Route path='/industries/healthcare' element={<IndHealthcare />} />
            <Route path='/industries/high-tech' element={<IndHighTech />} />
            <Route path='/industries/information-technology' element={<IndInformationTechnology />} />
            <Route path='/industries/insurance' element={<IndInsurance />} />
            <Route path='/industries/life-sciences' element={<IndLifeSciences />} />
            <Route path='/industries/manufacturing' element={<IndManufacturing />} />
            <Route path='/industries/public-service' element={<IndPublicService />} />
            <Route path='/industries/retail' element={<IndRetail />} />
            <Route path='/industries/real-estate' element={<IndRealEstate />} />
            <Route path='/industries/travel-and-logistics' element={<IndTravelLogistics />} />
            <Route path='/service-section' element={<ServiceSection/>} />
            <Route path='/test' element={<TestComponent />} />
            <Route path='/portfolio' element={<Works />} />
            <Route path='/portfolio/:slug' element={<WorkDetails />} />
          </Route>

          <Route path='/codezion-ai' element={<ModernAiChatbot />} />
          <Route path='/codezion-ai/settings' element={<AiSettingsPage />} />
          <Route path='*' element={<Error />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    {/* </HelmetProvider> */}
    </ThemeProvider>
  );
}

export default App;

